const messageKeys = {
  active_station_required: 'reportChooseWorkplace',
  no_data: 'noDataTitle',
  invalid_request: 'reportParametersInvalid',
  invalid_parameter: 'reportParametersInvalid',
  invalid_parameter_range: 'reportParametersInvalid',
  unknown_parameter: 'reportParametersInvalid',
  hidden_parameter: 'reportParametersInvalid',
  parameter_dependency_failed: 'reportRequiredParametersMissing',
  parameter_options_too_large: 'reportParametersUnavailable',
  parameter_form_failed: 'reportParametersUnavailable',
  template_not_found: 'reportTemplateUnavailable',
  template_load_failed: 'reportTemplateUnavailable',
  template_version_mismatch: 'reportTemplateUnavailable',
  product_range_unsupported: 'reportTemplateUnsupported',
  unsupported_template: 'reportTemplateUnsupported',
  unsupported_format: 'reportExportUnavailable',
  invalid_export_content_type: 'reportExportUnavailable',
  renderer_unavailable: 'reportServiceUnavailable',
  engine_unavailable: 'reportServiceUnavailable',
  contract_mismatch: 'reportServiceUnavailable',
  renderer_busy: 'reportServiceBusy',
  renderer_timeout: 'reportServiceTimeout',
  renderer_cancelled: 'reportRequestCancelled',
  invalid_chart_contract: 'chartContractFailed',
  report_failed: 'reportGenerationFailed',
  chart_failed: 'chartFailed',
}
const fallbackKeys = {
  parameters: 'reportParametersUnavailable',
  pdf: 'pdfFailed',
  chartPdf: 'chartPdfFailed',
  xlsx: 'xlsxFailed',
  html: 'htmlFailed',
  chart: 'chartFailed',
}

// Server messages and identifiers are never part of the text shown to a report user.
export function reportErrorMessage(error, t, operation = 'report') {
  if (error?.status === 401) return t('reportSessionExpired')
  if (error?.status === 403 || error?.code === 'permission_denied') return t('reportAccessDenied')
  const key = Object.hasOwn(messageKeys, error?.code) ? messageKeys[error.code]
    : error?.status === 404 ? 'reportTemplateUnavailable'
      : Object.hasOwn(fallbackKeys, operation) ? fallbackKeys[operation] : 'reportGenerationFailed'
  return t(key)
}
